import React, {useState} from "react";
import strapi from "/scripts/apis/strapi/index.js";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import Button from "@/components/button";
import { StrapiPicture } from "@/components/picture";

export default function ArticlePage({article}) {
  let author = article?.attributes?.author?.data?.attributes;
  let schema = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "headline": article.attributes.headline,
    "image": [article?.attributes?.coverArt?.data?.attributes.url],
    "datePublished": article.attributes.publishedAt,
    "dateModified": article.attributes.updatedAt,
    "author": [
      {
        "@type": "Person",
        "name": author?.name,
      },
    ],
  };

  return <DefaultLayout
    title={`${article.attributes.headline} | Lazy Prompts`}
    description={article.attributes.description}
    mainClassName={css.main}
    schema={schema}
    shareImageUrl={article?.attributes?.coverArt?.data?.attributes?.url}
  >
    <section className={`light ${css.article}`}>
      <div className="sectionInner">
        <div className={css.publishedAt}>Published {(new Date(article.attributes.createdAt)).toLocaleDateString()}</div>
        <h2>{article.attributes.headline}</h2>
        <div className={css.coverArt}>
          <StrapiPicture
            picture={article?.attributes?.coverArt?.data?.attributes}
            sizes="max-width(720px) 100vw, 1500px"
            loading="eager"
          />
        </div>
        <div className={css.articleWrapper}>
          <div className={css.subheadline}>{article.attributes.subheadline}</div>
          <article dangerouslySetInnerHTML={{__html: article.attributes.content}}></article>
          <div className={css.footnotes}>
            {author && <div className={css.attribution}>
              <div className={css.profilePicture}>
                <StrapiPicture
                  picture={author?.profilePicture?.data?.attributes}
                  sizes="200px"
                  loading="eager"
                />
              </div>
              <div className={css.author}>
                <div className={css.label}>Written by</div>
                <div className={css.name}>{author?.name}</div>
              </div>
            </div>}
            <div className={css.startSelling}>
              <Button label="Buy Enterprise Prompts" href="/listings?aiModel=&query=&business=true&tags=%5B%5D"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </DefaultLayout>;
}

//one path for each session
export async function getStaticPaths() {
  let articles = (await strapi.query(strapi.endpoints.ARTICLES_FIND, {
    fields: ["slug"],
  }));

  return {
    paths: articles.map((article) => {
      return {params: {article: article.attributes.slug}};
    }),
    fallback: "blocking",
  };
}
export async function getStaticProps(query) {
  let article = (await strapi.query(strapi.endpoints.ARTICLES_FIND, {
    filters: {
      slug: {
        $eq: query.params.article,
      },
    },
    populate: {
      coverArt: "*",
      author: {
        populate: "*",
      },
    },
    publicationState: query.preview ? "preview" : "live",
  }))[0];

  if (!article){
    return {
      redirect: {
        destination: "/404",
        permanent: false,
      },
      revalidate: 60,
    };
  }


  return {
    props: {
      article,
    },
    revalidate: 60,
  };
}
